/* eslint-disable */
import stripIndent from '../../Vendor/strip-indent';

/**
 * Thrown when the String length of a given `lang` is invalid
 * @export
 * @class I18nInvalidLangLengthError
 * @extends {Error}
 */
export class I18nInvalidLangLengthError extends Error {
  /**
   * Creates an instance of I18nInvalidLangLengthError
   * @param {string} message The Error `message`
   * @memberof I18nInvalidLangLengthError
   */
  constructor(message) {
    super(message);
    this.name = `I18nInvalidLangLengthError`;
  }
}

/**
 * Called when the String length of a given `lang` is invalid
 * @param {string} lang The invalid `lang`
 * @returns {never} never
 */
const throwI18nInvalidLangLengthError = (lang) => {
  throw new I18nInvalidLangLengthError(
    stripIndent(`
    Expected "lang" to have a "length" greater than "0";
    Got: "${lang}"
    `),
  );
};

export default throwI18nInvalidLangLengthError;
